<template>
  <div class="qr-code-page">
    <div v-if="loading" class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900 mx-auto"></div>
        <p class="mt-4">{{ $t('loading', 'Loading...') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Qrcode',
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    if (this.$route.params.qrcode) {
      this.handleQrCodeRedirect()
    }
  },
  methods: {
    // Check if URL is relative
    isRelativeUrl(url) {
      try {
        const parsedUrl = new URL(url)
        const hostname = window.location.hostname.replace('dev.tourio.com', 'tourio.com')
        return parsedUrl.hostname === hostname
      } catch (error) {
        // Invalid URL, treat it as relative
        return true
      }
    },
    
    // Handle QR code redirect
    async handleQrCodeRedirect() {
      console.log('navigate is loaded, we\'re ready to redirect')
      console.log(this.$route.params)
      
      const qrcode = this.$route.params.qrcode
      console.log(`checking code ${qrcode}`)
      
      // Track page view
      if (window._paq) {
        window._paq.push(['setCustomUrl', this.$route.path])
        window._paq.push(['setDocumentTitle', 'QR Code ' + qrcode])
        window._paq.push(['trackPageView'])
      }
      
      try {
        const response = await axios.get(process.env.CLIENT_API_URL + `/qr/${qrcode}`)
        this.loading = false
        
        const destinationUrl = response.data.destination
        if (destinationUrl) {
          try {
            const parsedUrl = new URL(destinationUrl)
            
            if (this.isRelativeUrl(destinationUrl)) {
              // Redirect to the received destination URL
              console.log('isRelativeUrl')
              const path = `${parsedUrl.pathname}`
              console.log('QrCode navigate to ' + path)
              this.$router.replace(path)
            } else {
              // Handle absolute URL redirection (also to external urls because the QR code is valid)
              console.log('window.open ' + destinationUrl)
              window.open(destinationUrl, '_self')
            }
          } catch (e) {
            console.log(e)
            console.log('error, redirect to /points')
            this.$router.replace('/points')
          }
        } else {
          // If the code is invalid, redirect to /points
          console.log('the code is invalid, redirect to /points')
          this.$router.replace('/points')
        }
      } catch (error) {
        // Handle errors
        console.log('API request failed')
        console.error(error)
        this.$router.replace('/points')
      }
    }
  }
}
</script>

<style scoped>
.qr-code-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}
</style> 